// Mock data para Repara Tu Cuerpo

export const servicios = [
  {
    id: 1,
    titulo: 'Dolor de Espalda',
    descripcion: 'Ejercicios y automasajes específicos para aliviar el dolor lumbar y dorsal',
    icono: 'BackPain'
  },
  {
    id: 2,
    titulo: 'Dolor Cervical',
    descripcion: 'Técnicas efectivas para reducir la tensión y el dolor en cuello y hombros',
    icono: 'NeckPain'
  },
  {
    id: 3,
    titulo: 'Lesiones Deportivas',
    descripcion: 'Recuperación y prevención de lesiones musculares y articulares',
    icono: 'Sport'
  },
  {
    id: 4,
    titulo: 'Dolor de Rodilla',
    descripcion: 'Tratamiento y ejercicios para problemas articulares de rodilla',
    icono: 'Knee'
  }
];

export const videosYoutube = [
  {
    id: 1,
    titulo: 'Ejercicios para Dolor Lumbar',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    duracion: '12:30'
  },
  {
    id: 2,
    titulo: 'Automasaje Cervical',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    duracion: '8:45'
  },
  {
    id: 3,
    titulo: 'Estiramientos para Ciática',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    duracion: '10:20'
  },
  {
    id: 4,
    titulo: 'Ejercicios para Hombro',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    duracion: '15:00'
  },
  {
    id: 5,
    titulo: 'Movilidad de Cadera',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    duracion: '9:15'
  },
  {
    id: 6,
    titulo: 'Dolor de Rodilla',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    duracion: '11:30'
  }
];

export const preciosServicios = [
  {
    id: 1,
    nombre: 'Consulta Online',
    precio: 30,
    duracion: 25,
    descripcion: 'Sesión individual personalizada por videollamada',
    caracteristicas: [
      'Evaluación completa de tu caso',
      'Plan de ejercicios personalizado',
      'Técnicas de automasaje específicas',
      'Seguimiento y recomendaciones'
    ]
  }
];

export const horariosDisponibles = [
  '10:00', '11:00', '12:00', '13:00',
  '16:00', '17:00', '18:00', '19:00'
];

export const testimonios = [
  {
    id: 1,
    nombre: 'María García',
    testimonio: 'Gracias a los ejercicios de Repara Tu Cuerpo, he podido eliminar mi dolor lumbar crónico. ¡Increíble!',
    rating: 5
  },
  {
    id: 2,
    nombre: 'Carlos Ruiz',
    testimonio: 'Profesional excepcional. La consulta online fue muy clara y efectiva. Ya noto mejoría.',
    rating: 5
  },
  {
    id: 3,
    nombre: 'Ana Martínez',
    testimonio: 'Los videos de YouTube son muy didácticos. La consulta privada me ayudó a personalizar mi tratamiento.',
    rating: 5
  }
];

export const articulosBlog = [
  {
    id: 1,
    slug: 'tratamiento-osteopatico-dolor-lumbar',
    titulo: 'Tratamiento Osteopático para el Dolor Lumbar',
    extracto: 'El dolor lumbar es una de las dolencias más comunes. Descubre cómo la osteopatía puede ayudarte a aliviarlo de forma natural y efectiva.',
    contenido: `El dolor lumbar afecta a 8 de cada 10 personas en algún momento de su vida. La osteopatía ofrece un enfoque integral para tratar esta condición.

## ¿Qué causa el dolor lumbar?

Las causas más comunes incluyen:
- Malas posturas prolongadas
- Movimientos repetitivos
- Sobrecarga muscular
- Problemas en las vértebras
- Estrés y tensión

## Tratamiento osteopático

El tratamiento osteopático se enfoca en:

1. **Evaluación completa**: Identificar la causa raíz del dolor
2. **Manipulaciones suaves**: Restaurar la movilidad de las vértebras
3. **Técnicas de tejidos blandos**: Relajar la musculatura
4. **Ejercicios personalizados**: Fortalecer y prevenir recaídas

## Beneficios del tratamiento

- Alivio del dolor sin medicación
- Mejora de la movilidad
- Prevención de futuras lesiones
- Tratamiento de la causa, no solo el síntoma

Si sufres de dolor lumbar, la osteopatía puede ser tu mejor aliado para recuperar tu calidad de vida.`,
    imagen: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80',
    categoria: 'Dolor de Espalda',
    fecha: '2024-03-15',
    autor: 'Dr. Osteopatía'
  },
  {
    id: 2,
    slug: 'osteopatia-dolor-cervical',
    titulo: 'Osteopatía y Dolor Cervical: Solución Natural',
    extracto: 'El dolor de cuello es cada vez más común debido al uso de dispositivos móviles y largas jornadas frente al ordenador. La osteopatía ofrece soluciones efectivas.',
    contenido: `El dolor cervical, también conocido como cervicalgia, es una dolencia que afecta a millones de personas, especialmente en la era digital.

## Causas principales

- Uso prolongado de smartphones y ordenadores
- Malas posturas al dormir
- Estrés y tensión emocional
- Traumatismos cervicales
- Artrosis cervical

## Enfoque osteopático

La osteopatía trata el dolor cervical mediante:

### Técnicas manuales
- Movilizaciones suaves de las vértebras cervicales
- Liberación de la musculatura del cuello y hombros
- Tratamiento de puntos gatillo

### Consejos ergonómicos
- Ajuste de la postura en el trabajo
- Ejercicios de estiramiento
- Técnicas de relajación

## Prevención

Para prevenir el dolor cervical:
1. Mantén la pantalla a la altura de los ojos
2. Realiza pausas cada 30 minutos
3. Practica ejercicios de movilidad cervical
4. Gestiona el estrés adecuadamente

La osteopatía no solo alivia el dolor, sino que te enseña a prevenir futuras molestias.`,
    imagen: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80',
    categoria: 'Dolor Cervical',
    fecha: '2024-03-10',
    autor: 'Dr. Osteopatía'
  },
  {
    id: 3,
    slug: 'tratamiento-lesiones-deportivas-osteopatia',
    titulo: 'Tratamiento de Lesiones Deportivas con Osteopatía',
    extracto: 'Los deportistas requieren tratamientos especializados. Descubre cómo la osteopatía acelera la recuperación y mejora el rendimiento.',
    contenido: `Las lesiones deportivas son comunes en atletas de todos los niveles. La osteopatía es una herramienta fundamental en la recuperación.

## Lesiones más comunes

### Lesiones musculares
- Contracturas
- Desgarros
- Sobrecargas

### Lesiones articulares
- Esguinces
- Tendinitis
- Bursitis

## Beneficios de la osteopatía deportiva

1. **Recuperación más rápida**: Técnicas que aceleran la curación
2. **Prevención de lesiones**: Identificación de desequilibrios
3. **Mejora del rendimiento**: Optimización de la función biomecánica
4. **Tratamiento integral**: Aborda causa y síntomas

## Protocolo de tratamiento

### Fase aguda
- Reducción de la inflamación
- Control del dolor
- Protección de la zona

### Fase de recuperación
- Restauración de la movilidad
- Fortalecimiento progresivo
- Ejercicios funcionales

### Fase de retorno
- Entrenamiento específico
- Prevención de recaídas
- Optimización del rendimiento

La osteopatía deportiva es esencial para cualquier atleta que busque mantener su máximo nivel.`,
    imagen: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80',
    categoria: 'Lesiones Deportivas',
    fecha: '2024-03-05',
    autor: 'Dr. Osteopatía'
  },
  {
    id: 4,
    slug: 'dolor-rodilla-tratamiento-osteopatico',
    titulo: 'Dolor de Rodilla: Enfoque Osteopático',
    extracto: 'La rodilla es una articulación compleja. La osteopatía ofrece tratamientos efectivos para diversos problemas de rodilla.',
    contenido: `El dolor de rodilla puede limitar significativamente la calidad de vida. La osteopatía aborda esta problemática de forma integral.

## Causas del dolor de rodilla

- Sobrecarga por actividad física
- Desgaste articular (artrosis)
- Lesiones de menisco o ligamentos
- Problemas de alineación
- Debilidad muscular

## Evaluación osteopática

El osteópata evalúa:
- La alineación de pierna y cadera
- La movilidad articular
- El estado de la musculatura
- Patrones de movimiento

## Tratamiento

### Técnicas manuales
- Movilizaciones articulares suaves
- Liberación de tejidos blandos
- Trabajo sobre puntos gatillo

### Ejercicio terapéutico
- Fortalecimiento del cuádriceps
- Estabilización de la rodilla
- Mejora del equilibrio
- Estiramientos específicos

## Prevención

Para mantener rodillas sanas:
1. Mantén un peso saludable
2. Fortalece la musculatura de las piernas
3. Calienta antes de hacer ejercicio
4. Usa calzado adecuado
5. Evita impactos excesivos

La osteopatía es una excelente opción para tratar y prevenir problemas de rodilla sin cirugía.`,
    imagen: 'https://images.unsplash.com/photo-1530822847156-5df684ec5ee1?w=800&q=80',
    categoria: 'Dolor de Rodilla',
    fecha: '2024-02-28',
    autor: 'Dr. Osteopatía'
  },
  {
    id: 5,
    slug: 'ciatica-tratamiento-osteopatico',
    titulo: 'Ciática: Cómo la Osteopatía Puede Ayudarte',
    extracto: 'El dolor ciático puede ser debilitante. Descubre cómo la osteopatía trata la causa raíz de este problema.',
    contenido: `La ciática es un dolor que se irradia desde la espalda baja hacia la pierna, siguiendo el recorrido del nervio ciático.

## ¿Qué es la ciática?

La ciática no es una enfermedad en sí, sino un síntoma causado por:
- Hernia discal
- Estenosis espinal
- Síndrome del piramidal
- Espondilolistesis
- Tensión muscular excesiva

## Síntomas característicos

- Dolor punzante en la pierna
- Hormigueo o entumecimiento
- Debilidad muscular
- Dificultad para caminar
- Dolor al estar sentado

## Tratamiento osteopático

### Evaluación detallada
El osteópata identifica la causa específica mediante:
- Examen físico completo
- Tests neurológicos
- Análisis postural

### Técnicas de tratamiento

1. **Manipulaciones vertebrales**: Para liberar presión sobre el nervio
2. **Trabajo muscular profundo**: Relajación de la musculatura lumbar y glútea
3. **Estiramientos específicos**: Del nervio ciático y músculos asociados
4. **Movilizaciones articulares**: De pelvis y cadera

## Ejercicios en casa

Complementa el tratamiento con:
- Estiramientos del piramidal
- Fortalecimiento del core
- Movilidad de cadera
- Ejercicios de McKenzie

## Prevención

- Mantén buena postura
- Fortalece la musculatura lumbar
- Evita estar mucho tiempo sentado
- Levanta objetos correctamente

El tratamiento osteopático para la ciática es efectivo y sin efectos secundarios, abordando la causa del problema.`,
    imagen: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=800&q=80',
    categoria: 'Dolor de Espalda',
    fecha: '2024-02-20',
    autor: 'Dr. Osteopatía'
  },
  {
    id: 6,
    slug: 'sindrome-tunel-carpiano-osteopatia',
    titulo: 'Síndrome del Túnel Carpiano: Tratamiento Natural',
    extracto: 'El túnel carpiano afecta a muchas personas que trabajan con las manos. La osteopatía ofrece soluciones sin cirugía.',
    contenido: `El síndrome del túnel carpiano es una compresión del nervio mediano a nivel de la muñeca, causando dolor y entumecimiento.

## Causas principales

- Movimientos repetitivos de muñeca
- Trabajo prolongado con ordenador
- Retención de líquidos
- Factores genéticos
- Embarazo

## Síntomas

- Dolor y hormigueo en dedos pulgar, índice y medio
- Pérdida de fuerza en la mano
- Dificultad para agarrar objetos
- Dolor nocturno
- Entumecimiento que sube por el brazo

## Tratamiento osteopático

### Enfoque integral
La osteopatía no solo trata la muñeca, sino toda la cadena:
- Cervicales (de donde sale el nervio)
- Hombro y codo
- Antebrazo
- Muñeca y mano

### Técnicas específicas

1. **Liberación del túnel carpiano**: Técnicas suaves para descomprimir el nervio
2. **Movilizaciones de muñeca**: Restaurar la movilidad normal
3. **Trabajo muscular**: Relajar flexores y extensores del antebrazo
4. **Ajustes cervicales**: Optimizar la salida del nervio desde la columna

## Automasajes y ejercicios

Para aliviar síntomas:
- Estiramientos de muñeca y dedos
- Ejercicios de deslizamiento nervioso
- Movilizaciones suaves
- Descansos frecuentes

## Prevención

1. Ergonomía en el puesto de trabajo
2. Pausas cada 30-45 minutos
3. Variación de movimientos
4. Fortalecimiento de antebrazo
5. Mantener muñecas en posición neutra

La osteopatía es una excelente alternativa a la cirugía para el túnel carpiano.`,
    imagen: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80',
    categoria: 'Dolor de Mano',
    fecha: '2024-02-15',
    autor: 'Dr. Osteopatía'
  }
];